<template>
  <NuxtLoadingIndicator color="#C8963E" :height="3" />
  <NuxtLayout>
    <NuxtPage :transition="{ name: 'page', mode: 'out-in' }" />
  </NuxtLayout>
</template>
